<template>
  <div class="field-set">
    <label
      class="label"
      v-bind:for="getFieldId(field.name)"
    >
      {{field.label.text}}
      <strong
        v-if="field.mandatory"
        class="field--required"
      >*</strong>
    </label>
    <input
      class="field__input"
      v-bind:id="getFieldId(field.name)"
      v-bind:type="field.type"
      v-bind:name="field.name"
      v-bind:value="field.value"
      v-model="answer"
      v-on:change="updateValue"
      v-bind:autocomplete="autocomplete"
      v-validate="validate"
    />
    <div class="is-danger" v-show="errors.has(field.name)">{{ getErrorMsg(field.name) }}</div>
  </div>
</template>

<script>
// @ is an alias to /src
import field from '@/components/mixin/field';

export default {
  name: 'TextInput',
  mixins: [field],
  props: [
    'field',
    'validate',
    'autocomplete',
    'errorMsg',
    'initial',
  ],
};
</script>
